var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircleCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36431_418850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.14683 2.16927C4.42448 2.14711 4.68826 2.03772 4.90022 1.85703C5.37138 1.45574 5.97004 1.23535 6.58892 1.23535C7.2078 1.23535 7.80672 1.45593 8.27782 1.85721C8.4898 2.0379 8.75341 2.14711 9.03102 2.16927C9.64817 2.21859 10.2274 2.48609 10.6652 2.9238C11.1029 3.36152 11.3704 3.94123 11.4197 4.55829C11.4417 4.83559 11.5513 5.09961 11.7319 5.31135C12.1332 5.78251 12.3536 6.38118 12.3536 7.00005C12.3536 7.61893 12.133 8.2178 11.7318 8.68895C11.5511 8.90093 11.4419 9.16454 11.4197 9.44215C11.3704 10.0593 11.1029 10.6386 10.6652 11.0764C10.2274 11.5141 9.64817 11.7816 9.03102 11.8309C8.75341 11.853 8.48955 11.9624 8.27757 12.1431C7.80646 12.5443 7.2078 12.7648 6.58892 12.7648C5.97004 12.7648 5.37117 12.5441 4.90001 12.1429C4.68805 11.9622 4.42443 11.853 4.14678 11.8309C3.52972 11.7816 2.95039 11.5141 2.51267 11.0764C2.07495 10.6386 1.80745 10.0593 1.75813 9.44215C1.73597 9.16454 1.62659 8.90068 1.44589 8.68879C1.04461 8.2176 0.824219 7.61893 0.824219 7.00005C0.824219 6.38118 1.04479 5.7823 1.44607 5.31114C1.62676 5.09918 1.73598 4.83556 1.75814 4.55791C1.80746 3.94085 2.07495 3.36152 2.51267 2.9238C2.95039 2.48609 3.52977 2.21858 4.14683 2.16927ZM4.14683 2.16927L3.70657 2.31623",
    stroke: "#007A5A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50781 6.68969L5.94565 8.10506L8.50172 5.89258",
    stroke: "#007A5A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36431_418850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1765,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleCurve);
export default __webpack_public_path__ + "static/media/check-circle-curve.a93251980ab4457cd0d9daa6416b5e6a.svg";
export { ForwardRef as ReactComponent };